import React from 'react';
import '../../App.css';

class ImageProfile extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loaded: false,
            alreadyLoaded: false,
        };
    }

    changeLoad = () => {
        if(this.state.alreadyLoaded)
            return
        this.setState({ loaded: true, alreadyLoaded: true})
    }

    render() {
        const letter = this.props.name.charAt(0) || "U"
        return (
            <div>
                {this.state.loaded ? null : (
                    <div>
                        <div style={{ display: "flex", height: this.props.height, width: this.props.height, borderRadius: "50%", backgroundColor: "#ccc", justifyContent: "center" }}>
                            <h1 style={{ justifyContent: "center", alignSelf: "center", color: "white", fontWeight: "bold", fontSize: this.props.height / 2, marginBottom: 2 }}>
                                {letter.toUpperCase()}
                            </h1>
                        </div>
                    </div>
                    
                )}
                <img
                    style={{ display: this.state.loaded ? "block" : 'none', height: this.props.height, width: this.props.height, borderRadius: "50%", objectFit:"cover", }}
                    src={this.props.avatar }
                    onLoad={this.changeLoad}
                    alt="avatar"
                />
            </div>
        );
    }
}

export default ImageProfile